import { Component } from '@angular/core';
import {
  BusinessReasonCode,
  MeteringPointType,
  ProductCharacteristicIdentification,
  RequestAggregatedMeteredDataCommand,
  SettlementMethod,
  SettlementService
} from '@app/api/dmc';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormApiService } from '@app/core/services/form-api.service';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { KeyValue } from '@shared/interfaces/key-value/key-value';
import { enumToKeyValue } from '@app/core/utils/enum-to-key-value';
import { SelectDirective } from '@shared/components/input/select/select.directive';
import { HasUnsavedChanges } from '@app/core/guards/unsaved-changes.guard';

@Component({
  selector: 'app-settlement-metered-request-modal',
  imports: [
    ReactiveFormsModule,
    InputGroupComponent,
    LabelDirective,
    InputDirective,
    TranslatePipe,
    SelectDirective
  ],
  templateUrl: './settlement-metered-request-modal.component.html',
  styleUrl: './settlement-metered-request-modal.component.css'
})
export class SettlementMeteredRequestModalComponent implements HasUnsavedChanges {
  public hasUnsavedChanges(): boolean {
    return this.form.dirty;
  }

  public form: FormGroup = new FormGroup({
    start: new FormControl(null, [Validators.required]),
    end: new FormControl(null, [Validators.required]),
    businessReasonCode: new FormControl(null, [Validators.required]),
    meteringPointType: new FormControl(null, [Validators.required]),
    productCharacteristicIdentification: new FormControl(null),
    settlementMethod: new FormControl(null),
  })

  public businessReasonCodeList: KeyValue[] = enumToKeyValue(BusinessReasonCode, { prefixValue: 'enum.settlement.businessreasoncode.', includeKeys: ['Temporary', 'FirstSettlement', 'SecondSettlement', 'CorrectionSettlement'] });
  public meteringPointTypeList: KeyValue[] = enumToKeyValue(MeteringPointType, { prefixValue: 'enum.meteringpoint.meteringpointtype.', includeKeys: ['GridLossCorrection', 'Consumption', 'Production', 'Exchange'] });
  public settlementMethodList: KeyValue[] = enumToKeyValue(SettlementMethod, { prefixValue: 'enum.meteringpoint.settlementmethod.', omitKeys: ['NotSpecified'] });
  public productList: KeyValue[] = enumToKeyValue(ProductCharacteristicIdentification, { prefixValue: 'enum.meteringpoint.productcharacteristic.', omitKeys: ['NotSpecified'] });

  constructor(
    private readonly settlementService: SettlementService,
    private readonly formApiService: FormApiService,
  ) {
  }

  public submit(): void {
    this.formApiService.submit(
      this.form,
      (data: RequestAggregatedMeteredDataCommand) => this.settlementService.settlementRequestAggregatedMeteredDataPost(data),
      {
        closeModal: true,
        successMessage: 'settlement.metered.request.success'
      }
    )
  }

}
